import React from "react";
import { useApiData } from "../hooks/useFetch.js";
import { api } from "../api/api.js";
import StateGuard from "./StateGuard.jsx";
import AleaChart from "../charts/AleaChart.jsx";
import { ALEA_INFO } from "../constants.js";

import iconGel from "../../../../assets/Aleas/gel.png";
import iconCDC from "../../../../assets/Aleas/cdc.png";
import iconEE from "../../../../assets/Aleas/ee.png";
import iconSHRU from "../../../../assets/Aleas/shru.png";
import iconCDF from "../../../../assets/Aleas/cdf.png";

const ALEA_ICONS = { Gel: iconGel, CDC: iconCDC, EE: iconEE, SHRU: iconSHRU, CDF: iconCDF };

export default function AleasTab({ baseParams }) {
  const { data, loading, error } = useApiData(api.getAleas, baseParams, {
    // gridno a disparu (la localisation est résolue côté API depuis
    // idExploitation) et idProdu s'appelle désormais idProduction : l'ancienne
    // condition était toujours vraie, donc l'appel n'était jamais lancé.
    skip: !baseParams.idExploitation || !baseParams.idProduction,
  });

  return (
    <div className="oad-panel">
      <h3>Aléas climatiques - jours/an (min / moyenne / max)</h3>
      <StateGuard
        loading={loading}
        error={error}
        empty={!data || data.length === 0}
        emptyMessage="Pas de données aléas pour ce point / culture."
      >
        {data && (
          <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
            {Object.keys(ALEA_INFO).map((code) => {
              const rows = data.filter((d) => d.alea === code);
              if (rows.length === 0) return null;
              return (
                <div key={code} style={{ flex: "1 1 200px", minWidth: 200, textAlign: "center" }}>
                  <img src={ALEA_ICONS[code]} alt={ALEA_INFO[code].label} style={{ width: 40, height: 40 }} />
                  <AleaChart data={rows} color={ALEA_INFO[code].color} title={ALEA_INFO[code].label} code={code} />
                </div>
              );
            })}
          </div>
        )}
      </StateGuard>
    </div>
  );
}